// ProjectsPage.tsx

import React, { useEffect, useRef } from "react";
import ProjectImage1 from "../../../assets/Hera_logo.png";
import ProjectImage2 from "../../../assets/logo_edf.png"; // Imp
import ProjectImage3 from "../../../assets/Mythos_Logo2.jpg"; // Imp
import { SelectedPage } from "../../../shared/types";
import { NavLink } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import { useExpandedProject } from "../../../Components/ExpandableProjects";
import { useSpring, animated, useTrail, config } from "react-spring";
import useOnScreen from "../../../hooks/useOnScreen";
import projects from "../../Projects/popolateProjects";
import { Project } from "../../../shared/interfaces";

type Props = {
  setSelectedPage(value: SelectedPage): void;
};

const HighlightedProject = ({
  project,
  index,
  setSelectedPage,
}: {
  project: Project;
  index: number;
  setSelectedPage: (value: SelectedPage) => void;
}) => {
  const [isAnimated, setAnimated] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref, "-100px");

  const { setExpandedProject } = useExpandedProject();

  const fadeIn = useTrail(index + 1, {
    opacity: isAnimated ? 1 : 0,
    config: { duration: 500 }, // Adjust the duration (in milliseconds) to your preference
  });

  React.useEffect(() => {
    if (isVisible) {
      setAnimated(true);
    }
  }, [isVisible]);

  const formatTitle = (title: string) => {
    return title.split("").map((letter, index) => {
      const isUpperCase = /[A-Z]/.test(letter);
      return (
        <span
          key={index}
          className={`${isUpperCase ? "font-bold text-palette3" : ""}`}
        >
          {letter}
        </span>
      );
    });
  };

  return (
    <animated.div ref={ref} style={fadeIn[index]} className="mb-8">
      <img
        src={project.logo}
        alt={project.id}
        className="w-full h-48 object-contain bg-palette5 mb-4 rounded"
      />
      <h3 className="text-2xl 2xl:text-4xl text-palette3 font-bold mb-2">
        {project.shortTitle}
      </h3>
      <h3 className="text-lg 2xl:text-2xl  mb-2">
        {formatTitle(project.title)}
      </h3>
      <p className="text-palette3 2xl:text-xl">{project.shortDescription}</p>
      <NavLink
        to={`/projects`}
        onClick={() => {
          setSelectedPage(SelectedPage.Projects);
          setExpandedProject(project.id);
        }}
      >
        <a
          href={project.link}
          className="text-palette1 mt-2 hover:underline inline-block"
        >
          Read More
        </a>
      </NavLink>
    </animated.div>
  );
};

function ProjectsPage({ setSelectedPage }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref);

  useEffect(() => {
    if (isVisible) {
      // Trigger any additional actions when the component is in view
    }
  }, [isVisible]);

  const highlightedProjects: Project[] = [
    projects.find((project) => project.id == "project5") ?? projects[4],
    projects.find((project) => project.id == "project7") ?? projects[6],
    projects.find((project) => project.id == "project6") ?? projects[5],
  ];
  // Inside the component
  return (
    <div className="bg-gray-100 mt-8 p-8">
      <h2 className="text-3xl lg:text-5xl font-bold text-center text-palette1 mb-12">
        Projects
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mx-16 sm:text-justify text-center">
        {highlightedProjects.map((project, index) => (
          <HighlightedProject
            key={index}
            project={project}
            index={index}
            setSelectedPage={setSelectedPage}
          />
        ))}
      </div>

      <div className="flex items-center justify-center mt-4">
        <NavLink
          to={`/projects`}
          onClick={() => {
            setSelectedPage(SelectedPage.Projects);
          }}
        >
          <button className="mt-4 bg-palette border border-palette3 text-palette3 px-4 py-2 rounded hover:bg-palette3 hover:text-palette5 transition-colors">
            All Projects
          </button>
        </NavLink>
      </div>
    </div>
  );
}

export default ProjectsPage;
